import getLang from 'I18n/utils/getLang';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useFeatureMonetizationTracker } from '../FeatureMonetizationTrackerProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductServiceCatalogPrompt = ({
  skuCategoryName
}) => {
  const tracker = useFeatureMonetizationTracker();
  return /*#__PURE__*/_jsx(View, {
    minBlockSize: "48px",
    children: /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      marginInlineStart: "500"
      // Maintain alignment with the parent feature
      ,
      paddingBlockStart: "100",
      paddingBlockEnd: "200",
      textAlign: "right",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "feature-monetization.productServicesCatalogPrompt.prompt",
        options: {
          link: /*#__PURE__*/_jsx(Link, {
            href: getProductServicesCatalogHref(),
            external: true,
            onClick: () => {
              tracker.track({
                action: 'clicked-product-services-catalog-link',
                skuCategoryName,
                object: 'product-services-catalog-link'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "feature-monetization.productServicesCatalogPrompt.linkText"
            })
          })
        }
      })
    })
  });
};
function getProductServicesCatalogHref() {
  const language = getLang() || 'en';
  let productServicesCatalogLanguage = language;
  const localizedLanguages = ['ja', 'es', 'fr', 'de', 'pt'];
  const base = 'https://legal.hubspot.com';
  if (language === 'ja') {
    productServicesCatalogLanguage = 'jp';
  } else if (language === 'pt') {
    productServicesCatalogLanguage = 'br';
  }
  return localizedLanguages.includes(language) ? `${base}/${productServicesCatalogLanguage}/hubspot-product-and-services-catalog` : `${base}/hubspot-product-and-services-catalog`;
}